<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div class="header-titles">
      <h2 class="modal-title">{{this.data.isHumEdit ? 'Scan Location' : 'Scan Inventory'}}</h2>
      <div class="modal-subtitle">
        {{this.data.isHumEdit ? 'Scan a warehouse, room, or location barcode' : 'Scan a tag or type a barcode, then press Enter'}}
      </div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close(null)">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>

  <div class="modal-body">
    <section class="form-section">
      <div class="scan-toggle" role="group" aria-label="Scan mode" *ngIf="!this.data.isHumEdit && !this.data.disableToggle">
        <button type="button" [class.on]="!this.data.isMultiple" [attr.aria-pressed]="!this.data.isMultiple"
          (click)="this.data.isMultiple = false">Single Scan</button>
        <button type="button" [class.on]="this.data.isMultiple" [attr.aria-pressed]="!!this.data.isMultiple"
          (click)="this.data.isMultiple = true">Bulk Scan</button>
      </div>

      <mat-form-field class="scan-field" appearance="outline" [nbSpinner]="this.isLoading">
        <mat-label>Barcode</mat-label>
        <fa-icon matPrefix [icon]="faBarcode" class="scan-icon"></fa-icon>
        <input [(ngModel)]="this.tagNumber" (keyup.enter)="scanTag()" matInput type="text"
          #tagNumberInput id="tagNumberInput" name="tagNumberInput" autocomplete="off">
      </mat-form-field>

      <div class="modal-error" role="alert" *ngIf="this.tagNotFound">
        <fa-icon [icon]="faCircleExclamation"></fa-icon>Tag not found. Please try another.
      </div>
    </section>

    <section class="form-section" *ngIf="data.isMultiple">
      <div class="section-head">
        <fa-icon [icon]="faListUl" class="section-icon"></fa-icon>
        <h3>Scanned</h3>
        <span class="count-pill">{{this.handlingUnitBulkMoveList.length}}</span>
      </div>
      <ul class="scanned-list" *ngIf="this.handlingUnitBulkMoveList.length; else noScans">
        <li *ngFor="let x of this.handlingUnitBulkMoveList; trackBy: trackByHum">
          <fa-icon [icon]="faCheck" class="scanned-icon"></fa-icon>{{x.tagNumber}}
        </li>
      </ul>
      <ng-template #noScans>
        <div class="modal-empty">Nothing scanned yet</div>
      </ng-template>
    </section>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="close(null)">Close</button>
    <button *ngIf="data.isMultiple" mat-raised-button color="primary" type="button"
      [disabled]="this.handlingUnitBulkMoveList.length <= 0" (click)="bulkMoveNext()">
      Next<fa-icon [icon]="faChevronRight" class="ms-2"></fa-icon>
    </button>
    <button *ngIf="!data.isMultiple" mat-raised-button color="primary" type="button" (click)="scanTag()">
      Next<fa-icon [icon]="faChevronRight" class="ms-2"></fa-icon>
    </button>
  </div>

</div>
